import { render, staticRenderFns } from "./teilnehmer-change-history.vue?vue&type=template&id=49f54589"
import script from "./teilnehmer-change-history.vue?vue&type=script&lang=js"
export * from "./teilnehmer-change-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports